
import enLocale from 'element-ui/lib/locale/lang/en'
export default {
  Cameras: 'Cameras',
  Playback: 'Playback',
  Events: 'Events',
  allDevices: 'All Devices',
  Connected: 'Connected',
  noConnected: 'Not Connected',
  SelectDate: 'Select a Date',
  Holdspeak: 'Hold & Speak',
  ClicktoStopInterc: 'Click to stop interc',
  ClicktoInterc: 'Click to interc',
  NoiseReduction: 'Noise reduction',
  SoundVolume: 'Sound volume',
  ManualAlarm: 'Manual Alarm',
  Sound: 'Sound',
  Light: 'Light',
  SoundLight: 'Sound & Light',
  SoundDetail: 'It will trigger an sound alarm.\nThe Alarm will turn off automatically in 30 seconds.',
  LightDetail: 'It will trigger an light alarm.\nThe Alarm will turn off automatically in 30 seconds.',
  SoundLightDetail: 'It will trigger an sound and light alarm.\nThe Alarm will turn off automatically in 30 seconds.',
  set: {
    es: 'Events Settings',
    rs: 'Recording Settings',
    as: 'Audio Settings',
    gs: 'General Settings',
    sd: 'Share Device'
  },
  cmodel: 'Model',
  name: 'Name',
  BatteryLevel: 'Battery Level',
  cfu: 'Check for firmwate update',
  RestartDevice: 'Restart Device',
  DeleteDevice: 'Delete Device',
  RemoveDevice: 'Remove Device',
  Copied: 'Copied',
  CopyFailed: 'Copy Failed',
  // dd:'',
  // dd:'',
  SpotlightSettings: 'Spotlight\nSettings',
  MotionDetection: 'Motion Detection',
  VideoSettings: 'Video Settings',
  AudioSettings: 'Audio Settings',
  Notification: 'Notification',
  GeneralSettings: 'General Settings',
  Settings: 'Settings',
  ViewAccount: 'View Account',
  MyService: 'My Service',
  AdditionalService: 'Additional Service',
  DeviceShare: 'Device Share',
  LabFeature: 'Lab Feature',
  HelpFeedback: 'Help & Feedback',
  DarkMode: 'Dark Mode',
  DeviceDisplayOrder: 'Device Display Order',
  Region: 'Region',
  About: 'About',
  AccountSettings: 'Account Settings',
  RNPU: 'Receive News and Product Updates',
  Email: 'Email',
  ChangePassword: 'Change Password',
  SignOut: 'Sign Out',
  Passwordlogin: 'Password login',
  Accountnumber: 'Account number',
  UEMnumber: 'Username/Email/Mobile number',
  pwd: 'Password',
  Ipwd: 'Input password',
  Forgotpassword: 'Forgot password？',
  Login: 'Login',
  Lac: 'Login and consent the <i>Terms of Service</i>, <i>Terms of Use</i>,<br> <i>Privacy Policy</i> and <i>Data Policy</i>.',
  MVCL: 'Mobile verification code login',
  APL: 'Account password login',
  Mobilelogin: 'Mobile login',
  Mobilenumber: 'Mobile number',
  VC: 'Verification Code',
  IVC: 'Input verification code',
  IMN: 'Input mobile number',
  GVC: 'Get verification code',
  HBS: 'Has been sent',
  Signup: 'Sign up',
  PETE: 'Please enter the email',
  PEMN: 'Please enter your mobile phone number',
  Iat: 'I agree to the <i>Terms of Service</i>, <i>Terms of Use</i>, <i>Privacy <br> Policy</i> and <i>Data Policy</i>.',
  Rpwd: 'Retrieve password',
  FAR: 'Fill in the account number to be retrieved',
  EMP: 'Email / Mobile phone',
  Confirm: 'Confirm',
  npwd: 'New password',
  inpwd: 'Input new password',
  cnpwd: 'Confirm new password',
  inpwda: 'Input new password again',
  AddDevice: 'Add Device',
  next: 'Next',
  icontip: {
    pre: 'previous video',
    xyz: 'next frame',
    suspend: 'play/suspend',
    next: 'next video',
    refresh: 'reload',
    ptz: 'direction control',
    speak: 'voice intercom',
    alarm: 'manual Alarm',
    light: 'light setting',
    quality: 'quality',
    jietu: 'screenshot',
    video: 'video record',
    set: 'camera setting',
    clos: 'mute switch',
    dld: 'download',
    speed: 'playback speed',
    full: 'play in full screen'
  },
  month: { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sept', 10: 'Oct', 11: 'Nov', 12: 'Dec' },
  Fluent: 'Fluent',
  SD: 'Standard definition',
  QHD: 'Quasi HD',
  RandS: 'Rotation and scaling',
  umwsv: 'Using the mouse wheel to scale the video',
  NDY: 'No devices yet',
  PEDU: 'Please enter the device UID',
  DU: 'Device UID',
  Cancel: 'Cancel',
  Add: 'Add',
  CNSD: 'Connection Succeeded',
  Connecting: 'Connecting',
  mediaerr: 'getUserMedia not supported on your browser!',
  LTO: 'Lights turned on',
  LTOF: 'Lights turned off',
  SetupMode: 'Setup Mode',
  PSWF: 'Please select a Wi-Fi network',
  PBT: 'Press the SYNC button for 2 seconds until you hear a beep, and LED is flashing blue.',
  UDS: 'Use your Device to scan the QR code. Once scanned, you will hear two beeps.',
  Delete: 'Delete',
  Restart: 'Restart',
  aysrs: 'Are you sure you want to restart your device?',
  drpw: 'The device is restarting. Please wait for a few minutes.',
  aydd: 'Are you sure you want to delete your device?',
  arusd: 'Are you sure you want to delete?',
  salot: 'Select at least one event type',
  AboutDevice: 'About Device',
  EventsSettings: 'Events Settings',
  RecordingSettings: 'Recording Settings',
  MAT: 'Motions Alert Tones',
  OHAM: 'Only human events will be recorded and pushed in the daytime. All motion will still be recorded and pushed at night time.',
  HO: 'Human Only',
  AM: 'All motion',
  AMR: 'All motion will be recorded and pushed both at day and night time.',
  asea: 'After saving the editing area，video will flash red when motion is detected.',
  NightVision: 'Night Vision',
  bwnv: 'B&W Night Vision',
  irled: 'The IR LED will turn on when motion is detected at night.',
  cnv: 'Color Night Vision',
  atsw: 'Automatically turn on spotlight when motion is detected at night. It records with color videos while it may be battery consuming.',
  TurnOff: 'Turn Off',
  tfled: 'Turn off the IR LED and spotlight when at night.',
  Storage: 'Storage',
  ModifyName: 'Modify Name',
  CameraName: 'Camera Name',
  nfmt: '2-30 characters, which can support Chinese, English and numbers',
  UpdateFirmware: 'Update Firmware',
  tnv: 'The new version',
  adyc: 'is available for download.Your current version is',
  InstallUpdates: 'Install Updates',
  cv: 'Current version',
  ntd: ',Firmware is up to date.',
  LogoWaterMark: 'Logo WaterMark',
  Definition: 'Definition',
  FIR: 'Fill in remarks',
  dnuv: 'Display notes in the upper right corner of the video.',
  RemarkName: 'Remark Name',
  Save: 'Save',
  mcp: 'Microphone(input)',
  hsar: 'Hold & Speak sound, Audio recording sound',
  Speaker: 'Speaker(output)',
  WiFiC: 'Wi-Fi Connection',
  SLED: 'Status LED',
  MountingGuide: 'Mounting Guide',
  LocalStorage: 'Local Storage',
  Video: 'Video',
  Available: 'Available',
  Format: 'Format',
  ShareDevice: 'Share Device',
  flmrs: 'Formatting local memory will remove all of the data stored in it. ',
  ut2s: 'Up to two activity zones can be set',
  dts: 'Detection Sensitivity',
  dtt: 'Detection Type',
  sea: 'Save Edit Area',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  ea1: 'Edit Area 1',
  ea2: 'Edit Area 2',
  ActivityZone: 'Activity Zone',
  EventAlarm: 'Event Alarm',
  CameraAlarm: 'Camera Alarm',
  Alarmsound: 'Alarm sound：',
  AlarmDuration: 'Alarm Duration：',
  dsaw: 'Define a specific area you want to detect.',
  Brightness: 'Brightness:',
  VideoRecording: 'Video Recording',
  AudioRecording: 'Audio Recording',
  CustomizeRecording: 'Customize Recording',
  vpses: 'Video playback sound,Event sound.',
  RestoreDefault: 'Restore Default',
  Cliplength: 'Clip length：',
  ibt: 'Intervals between triggers：',
  dywqc: 'Do you want to quit the changes?',
  sdoh: 'Select Device or Home',
  mh: 'My Homes',
  anh: 'Add New Home',
  shl: 'Set home location',
  hifm: 'Home Information',
  aystr: 'Are you sure to remove this home?',
  aystrr: 'Are you sure to remove this resident?',
  aystl: 'Are you sure to leave this home?',
  rmdfst: "Remove the home's devices first, then remove the home.",
  hnn: 'Home Nickname',
  mndv: 'Manage Devices',
  oprsd: 'Operation succeeded',
  Invite: 'Invite',
  sihss: 'Sharing invitation has been sent successfully.',
  ssd: 'Select sharing device',
  uifm: 'User Information',
  aysuds: 'Are you sure to delete the devices',
  dywup: 'Do you want to upgrade sharing permission level to Admin which will has full access?',
  Sddvc: 'Shared Devices',
  ManageHome: 'Manage Home',
  devices: 'devices',
  members: 'members',
  creator: 'creator',
  dName: 'Name',
  Address: 'Address',
  plen: 'Please enter a name',
  plea: 'Please enter the address',
  hrid: 'Home Residents',
  owner: 'owner',
  waiting: 'waiting',
  adrd: 'Add New Resident',
  lvhm: 'Leave Home',
  rmhm: 'Remove Home',
  mvdvc: 'Move device',
  invitation: ' invitation',
  etth: 'Enter the ',
  ywts: ' you want to share',
  EmailAddress: 'Email Address',
  fmtiv: ' format is invalid',
  Sdivt: 'Send Invitation',
  Administrators: 'Administrators',
  ivff: 'Invite family or friends',
  viewers: 'Viewers',
  sspm: 'Select sharing permission',
  OK: 'OK',
  // dd:'',
  ...enLocale
}



// WEBPACK FOOTER //
// ./src/locales/en.js